/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_DisconnectedInputs */

const cs_enum_disconnected = /** @type {(inputs: Enum_DisconnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odpojeno`)
};

const en_enum_disconnected = /** @type {(inputs: Enum_DisconnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disconnected`)
};

/**
* | output |
* | --- |
* | "Disconnected" |
*
* @param {Enum_DisconnectedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_disconnected = /** @type {((inputs?: Enum_DisconnectedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_DisconnectedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_disconnected(inputs)
	return cs_enum_disconnected(inputs)
});